import { Stack, StackProps } from "@mui/material"

export function PageWrapper(props: StackProps) {
  const { sx, ...rest } = props
  return (
    <Stack
      sx={{
        maxWidth: "1160px",
        margin: "0 auto",
        ...sx,
      }}
      {...rest}
    />
  )
}
